'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwPodGrid = require('./CwPodGrid.scss');

var _CwPodGrid2 = _interopRequireDefault(_CwPodGrid);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CwPodGridLoader = require('./CwPodGridLoader');

var _CwPodGridLoader2 = _interopRequireDefault(_CwPodGridLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwPodGrid = function CwPodGrid(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_CwPodGrid2.default.podGrid, (0, _defineProperty3.default)({}, _CwPodGrid2.default.defaultLayout, !props.customLayout)) },
    props.loader(props)
  );
};

CwPodGrid.propTypes = {
  maxColumns: _propTypes2.default.number,
  customLayout: _propTypes2.default.bool,
  loader: _propTypes2.default.func
};

CwPodGrid.defaultProps = {
  maxColumns: 2,
  loader: _CwPodGridLoader2.default
};

exports.default = CwPodGrid;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpodgrid/CwPodGrid.js
// module id = 849
// module chunks = 10